import type { PublicListingsNavigation } from "@/components/listings/PublicListings";

export const isPublicListingRuntimePath = (path: string) =>
  path === "/listing-sites" || path.startsWith("/listing-sites/");

const origin = "https://public-listings.invalid";
const validIdentity = (value: string) =>
  value.length > 0 && value.length <= 200 && value.trim() === value && !/^[.]{1,2}$|[\\/\p{Cc}]/u.test(value);

export const readPublicListingNavigation = ({
  basePath,
  location,
}: {
  basePath: string;
  location: string;
}): PublicListingsNavigation | null => {
  try {
    const base = new URL(basePath, origin);
    if (
      !basePath.startsWith("/") ||
      basePath.endsWith("/") ||
      base.origin !== origin ||
      base.pathname !== basePath ||
      base.search ||
      base.hash ||
      /[\\\s\p{Cc}]/u.test(basePath)
    )
      return null;
    const url = new URL(location, origin);
    if (!location.startsWith("/") || location.startsWith("//") || url.origin !== origin) return null;
    const params = url.searchParams;
    const path = url.pathname.replace(/\/$/, "");
    if (path !== basePath) {
      if (!path.startsWith(`${basePath}/listings/`)) return null;
      const parts = path.slice(`${basePath}/listings/`.length).split("/");
      if (parts.length !== 1 && (parts.length !== 3 || parts[1] !== "properties")) return null;
      params.append("listingId", decodeURIComponent(parts[0]));
      if (parts.length === 3) params.append("propertyId", decodeURIComponent(parts[2]));
    }
    if (["listingId", "propertyId", "scope"].some(key => params.getAll(key).length > 1)) return null;
    const listingId = params.get("listingId");
    const propertyId = params.get("propertyId");
    const scope = params.get("scope") ?? "on-market";
    if (
      (listingId !== null && !validIdentity(listingId)) ||
      (propertyId !== null && (!listingId || !validIdentity(propertyId))) ||
      !["on-market", "closed"].includes(scope)
    )
      return null;
    return { listingId, scope: scope === "closed" ? "closed" : "on-market", ...(propertyId ? { propertyId } : {}) };
  } catch {
    return null;
  }
};
